import API_BASE from './config';

export async function getTeams() {
    try {
        const res = await fetch(`${API_BASE}/teams`, { headers: { 'Accept': 'application/json' } });
        if (!res.ok) throw new Error('Network error');
        const ct = res.headers.get('content-type') || '';
        if (!ct.includes('application/json')) throw new Error('Non-JSON response');
        const data = await res.json();
        return Array.isArray(data) ? data : [];
    } catch (e) {
        console.error('teamsApi.getTeams error', e);
        return [];
    }
}

export function syncTeams(season = 'current') {
    return fetch(`${API_BASE}/teams/sync`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ season }),
    })
        .then((res) => {
            if (!res.ok) throw new Error('Failed to sync teams');
            return res.json();
        });
}
